import { render, staticRenderFns } from "./dynamicForm.vue?vue&type=template&id=ec49181a&scoped=true"
import script from "./dynamicForm.vue?vue&type=script&lang=js"
export * from "./dynamicForm.vue?vue&type=script&lang=js"
import style0 from "./dynamicForm.vue?vue&type=style&index=0&id=ec49181a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec49181a",
  null
  
)

export default component.exports